import { OptionalRegisterFormFieldElements } from 'components/authentication/RegisterForm';
import AuthenticationForm from 'components/AuthenticationForm';
import { EntryMethod, EntryMethodDetails } from 'components/enter/EntryMethod';
import { PageState } from 'components/enter/PageContent';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import PlainLoadingSpinner from 'components/PlainLoadingSpinner';
import Subheading from 'components/Subheading';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { ValueOf } from 'next/dist/shared/lib/constants';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { trackEecCheckoutStep3 } from 'utils/analytics/analytics';
import { scrollToSection } from 'utils/common';
import { ASSET_PREFIX } from 'utils/constants';
import { navigateToConfirmation } from 'utils/navigation';

interface IAuthenticationSection {
  setPageState: (state: ValueOf<typeof PageState>) => void;
}

const AuthenticationSection = observer(
  ({ setPageState }: IAuthenticationSection) => {
    const { entryMethod, handleContinueToPayment } = useEnterStore();
    const { currentUser } = useUserStore();
    const router = useRouter();
    const { displayToast } = useUIStore();

    const [
      startFreeSubscriptionButtonLoading,
      setStartFreeSubscriptionButtonLoading,
    ] = useState(false);

    return (
      <PaddedMaxWidthContainer id="authSection">
        <Subheading
          underlineColor={
            entryMethod
              ? EntryMethodDetails[entryMethod].underlineGlowColor
              : '#95F5DE'
          }
        >
          <div className="normal-case">Checkout</div>
        </Subheading>

        <img
          src={`${ASSET_PREFIX}/static/trust_pilot.svg`}
          alt="Trust Pilot Rating"
        />

        {startFreeSubscriptionButtonLoading && (
          <PlainLoadingSpinner style={{ margin: '4em 0 8em' }} />
        )}

        {!startFreeSubscriptionButtonLoading && currentUser !== null && (
          <p style={{ marginTop: 30, fontWeight: 600, fontSize: '1.3em' }}>
            ✔️ Logged in as <strong>{currentUser?.firstName}</strong>
          </p>
        )}

        {!startFreeSubscriptionButtonLoading && currentUser === null && (
          <AuthenticationForm
            submitButtonText={'Continue to payment'}
            onAuthentication={async (guestToken) => {
              await trackEecCheckoutStep3();
              const authenticatedAsGuest = !!guestToken;

              if (entryMethod === EntryMethod.FreeSubscription) {
                try {
                  const res = await handleContinueToPayment();

                  if (res) {
                    await navigateToConfirmation(
                      router,
                      res.orderId,
                      false,
                      EntryMethod.FreeSubscription,
                      true
                    );
                  }
                } catch (err) {
                  displayToast({
                    title: `Oops, something went wrong. Please try again later.`,
                    color: '#FF6600',
                    timeout: 9000,
                  });
                }
              } else {
                setPageState(PageState.PAYING);
                scrollToSection('#__next');
              }
            }}
            excludeFormFieldsList={[
              OptionalRegisterFormFieldElements.PHONE_NUMBER,
              OptionalRegisterFormFieldElements.DATE_OF_BIRTH,
              ...(entryMethod === EntryMethod.FreeSubscription
                ? [OptionalRegisterFormFieldElements.AGREED_TO_MARKETING]
                : []),
            ]}
          />
        )}
      </PaddedMaxWidthContainer>
    );
  }
);

export default AuthenticationSection;
